export const FlagUS = () => (
  <svg
    className="block h-full! w-full!"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_43_2776)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.4783 12H24C24 10.9169 23.8556 9.86765 23.5866 8.86954H11.4783V12Z"
        fill="#D80027"
      />
      <path
        d="M11.4783 5.73913H22.2387C21.5041 4.54044 20.5649 3.48092 19.4698 2.60867H11.4783V5.73913Z"
        fill="#D80027"
      />
      <path
        d="M12 24C14.8242 24 17.42 23.0239 19.4698 21.3913H4.53021C6.58006 23.0239 9.17585 24 12 24Z"
        fill="#D80027"
      />
      <path
        d="M1.76128 18.2609H22.2387C22.8285 17.2986 23.2858 16.2467 23.5866 15.1304H0.413391C0.714188 16.2467 1.17155 17.2986 1.76128 18.2609Z"
        fill="#D80027"
      />
      <path
        d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_43_2776">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const FlagEU = () => (
  <svg
    className="block h-full! w-full!"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_43_1471)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#0052B4"
      />
      <path
        d="M12 4.69566L12.3886 5.8914H13.6458L12.6286 6.63038L13.0172 7.82612L12 7.08708L10.9828 7.82612L11.3714 6.63038L10.3542 5.8914H11.6115L12 4.69566Z"
        fill="#FFDA44"
      />
      <path
        d="M6.83499 6.83503L7.9553 7.40578L8.84428 6.51685L8.64755 7.75856L9.76781 8.32936L8.52605 8.52605L8.32936 9.76786L7.75856 8.6476L6.51685 8.84433L7.40583 7.95535L6.83499 6.83503Z"
        fill="#FFDA44"
      />
      <path
        d="M4.69568 12L5.89141 11.6115V10.3542L6.63035 11.3714L7.82613 10.9829L7.08705 12L7.82613 13.0172L6.63035 12.6287L5.89141 13.6458V12.3886L4.69568 12Z"
        fill="#FFDA44"
      />
      <path
        d="M6.83499 17.165L7.40578 16.0447L6.51685 15.1557L7.75861 15.3525L8.32931 14.2322L8.52605 15.474L9.76777 15.6706L8.64764 16.2414L8.84428 17.4832L7.9553 16.5942L6.83499 17.165Z"
        fill="#FFDA44"
      />
      <path
        d="M12 19.3044L11.6114 18.1086H10.3542L11.3714 17.3696L10.9828 16.174L12 16.9129L13.0172 16.174L12.6286 17.3696L13.6458 18.1086H12.3885L12 19.3044Z"
        fill="#FFDA44"
      />
      <path
        d="M17.165 17.165L16.0447 16.5942L15.1557 17.4832L15.3524 16.2414L14.2322 15.6706L15.474 15.474L15.6706 14.2322L16.2414 15.3525L17.4831 15.1557L16.5941 16.0448L17.165 17.165Z"
        fill="#FFDA44"
      />
      <path
        d="M19.3043 12L18.1086 12.3886V13.6458L17.3696 12.6286L16.174 13.0172L16.9129 12L16.174 10.9829L17.3696 11.3714L18.1086 10.3542V11.6115L19.3043 12Z"
        fill="#FFDA44"
      />
      <path
        d="M17.165 6.83503L16.5942 7.95535L17.4832 8.84433L16.2413 8.64755L15.6706 9.76781L15.474 8.52605L14.2322 8.32931L15.3524 7.75856L15.1557 6.51689L16.0448 7.40583L17.165 6.83503Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_43_1471">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const FlagCA = () => (
  <svg
    className="block h-full! w-full!"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_43_1153)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M24 12C24 7.24247 21.2313 3.13172 17.2173 1.19072V22.8092C21.2313 20.8683 24 16.7575 24 12Z"
        fill="#D80027"
      />
      <path
        d="M0 12C0 16.7575 2.76867 20.8683 6.78263 22.8093V1.19072C2.76867 3.13172 0 7.24247 0 12Z"
        fill="#D80027"
      />
      <path
        d="M14.087 13.5652L16.1739 12.5217L15.1305 12V10.9565L13.0435 12L14.087 9.91303H13.0435L12 8.34783L10.9565 9.91303H9.91303L10.9565 12L8.86955 10.9565V12L7.82611 12.5217L9.91303 13.5652L9.39131 14.6087H11.4783V16.1739H12.5217V14.6087H14.6087L14.087 13.5652Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_43_1153">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const FlagSharedDev = () => (
  <svg
    className="block h-full! w-full!"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="#808080"
    />
    <path
      d="M12 4.8C7.58172 4.8 4.8 7.58172 4.8 12C4.8 16.4183 7.58172 19.2 12 19.2C16.4183 19.2 19.2 16.4183 19.2 12C19.2 7.58172 16.4183 4.8 12 4.8ZM12 17.6C8.68629 17.6 6.4 15.4137 6.4 12C6.4 8.68629 8.68629 6.4 12 6.4C15.4137 6.4 17.6 8.68629 17.6 12C17.6 15.4137 15.4137 17.6 12 17.6Z"
      fill="white"
    />
  </svg>
);

export const FlagStage6 = () => (
  <svg
    className="block h-full! w-full!"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="#4A90E2"
    />
    <path
      d="M12 4.8C7.58172 4.8 4.8 7.58172 4.8 12C4.8 16.4183 7.58172 19.2 12 19.2C16.4183 19.2 19.2 16.4183 19.2 12C19.2 7.58172 16.4183 4.8 12 4.8ZM12 17.6C8.68629 17.6 6.4 15.4137 6.4 12C6.4 8.68629 8.68629 6.4 12 6.4C15.4137 6.4 17.6 8.68629 17.6 12C17.6 15.4137 15.4137 17.6 12 17.6Z"
      fill="white"
    />
  </svg>
);

export const FlagStage8 = () => (
  <svg
    className="block h-full! w-full!"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="#50E3C2"
    />
    <path
      d="M12 4.8C7.58172 4.8 4.8 7.58172 4.8 12C4.8 16.4183 7.58172 19.2 12 19.2C16.4183 19.2 19.2 16.4183 19.2 12C19.2 7.58172 16.4183 4.8 12 4.8ZM12 17.6C8.68629 17.6 6.4 15.4137 6.4 12C6.4 8.68629 8.68629 6.4 12 6.4C15.4137 6.4 17.6 8.68629 17.6 12C17.6 15.4137 15.4137 17.6 12 17.6Z"
      fill="white"
    />
  </svg>
);

export const FlagAU = () => (
  <svg
    className="block h-full! w-full!"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="clipCircleAU">
        <circle
          cx="12"
          cy="12"
          r="12"
        />
      </clipPath>
      <clipPath id="clipUJAU">
        <rect
          width="12"
          height="12"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#clipCircleAU)">
      {/* Blue background */}
      <circle
        cx="12"
        cy="12"
        r="12"
        fill="#003DA5"
      />
      {/* Union Jack — upper-left quadrant */}
      <g clipPath="url(#clipUJAU)">
        {/* White saltire (St Andrew's cross) */}
        <path
          d="M2.12,0 L12,9.88 L9.88,12 L0,2.12 Z"
          fill="white"
        />
        <path
          d="M9.88,0 L12,2.12 L2.12,12 L0,9.88 Z"
          fill="white"
        />
        {/* Red saltire (St Patrick's cross) — drawn before the white cross so the cross takes precedence */}
        <path
          d="M1.06,0 L12,10.94 L10.94,12 L0,1.06 Z"
          fill="#C8102E"
        />
        <path
          d="M10.94,0 L12,1.06 L1.06,12 L0,10.94 Z"
          fill="#C8102E"
        />
        {/* White cross (St George) */}
        <rect
          x="0"
          y="4.5"
          width="12"
          height="3"
          fill="white"
        />
        <rect
          x="4.5"
          y="0"
          width="3"
          height="12"
          fill="white"
        />
        {/* Red cross (St George) */}
        <rect
          x="0"
          y="5.4"
          width="12"
          height="1.2"
          fill="#C8102E"
        />
        <rect
          x="5.4"
          y="0"
          width="1.2"
          height="12"
          fill="#C8102E"
        />
      </g>
      {/* Commonwealth Star — below the Union Jack */}
      <circle
        cx="5.5"
        cy="19"
        r="1.3"
        fill="white"
      />
      {/* Southern Cross constellation */}
      <circle
        cx="19.5"
        cy="12"
        r="1.1"
        fill="white"
      />
      <circle
        cx="15.5"
        cy="16.5"
        r="1.1"
        fill="white"
      />
      <circle
        cx="22.5"
        cy="15"
        r="0.9"
        fill="white"
      />
      <circle
        cx="20"
        cy="21"
        r="1.1"
        fill="white"
      />
      <circle
        cx="21.5"
        cy="18.5"
        r="0.55"
        fill="white"
      />
    </g>
  </svg>
);
